import { AuthService } from '@/services/common/auth.service';
import router from "@/router";
import { EventBus } from '@/helpers/event-bus.js';

const ErrorHandler = {

    errorResponseHandler (error) {
        if (error.message == 'Network Error') {
            EventBus.$emit('NetworkError', true);
        }

        // failed by refresh token
        if (error.code && (error.code == 401)) {
            AuthService.doLogout();
            return Promise.resolve(error.code);
        }

        // timeout api
        if (error.message == 'timeout of 30000ms exceeded') {
            EventBus.$emit('timeoutApi', true);
        }

        if (error.response) {
            // check if user not change password first login
            if (error.response.status === 302 && error.response.data.redirect.code === 1) {
                router.push('/changepassword');
            }

            // timeout 504
            if (error.response.status === 504) {
                EventBus.$emit('timeoutApi', true);
            }

            // Do something with response error
            if (error.response.status === 204) {
                error.response.message = 'No Content';
            }
            if (error.response.status === 400) {
                error.response.message = 'Bad Request';
            }
            if (error.response.status === 401) {
                error.response.message = 'Unauthorized';
            }
            if (error.response.status === 403) {
                error.response.message = 'Forbidden';
            }
            if (error.response.status === 404) {
                error.response.message = 'Not Found';
            }
            if (error.response.status === 409) {
                error.response.message = 'Conflict';
            }
            if (error.response.status === 500) {
                error.response.message = 'Network error. Please try again';
            }
            return Promise.reject(error.response);
        }
        return error;
    },
};

export default ErrorHandler;



// WEBPACK FOOTER //
// ./src/helpers/errorHandler.js